// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
angular
  .module('landingPage')
  .directive('squareGridLoad', ($window, $timeout) => ({
    restrict: 'E',

    link(scope, element, attr) {
      if (attr.displayData != null) {
        scope.assetsData = JSON.parse(attr.displayData);
      }
      scope.totalItemCount = scope.assetsData.length;
      scope.items = new Array(scope.totalItemCount); // needed in view to build empty grid
      scope.asyncGridLoaded = false;

      const init = () =>
        $window.addEventListener('load', () =>
          $timeout(() => scope.fetchRemainingAssets())
        );

      scope.getBackgroundImg = function (index) {
        if (!scope.asyncGridLoaded) {
          return '';
        }
        return (
          'url(' +
          (scope.assetsData[index] != null
            ? scope.assetsData[index].display_url
            : undefined) +
          ')'
        );
      };

      scope.fetchRemainingAssets = function () {
        if (scope.asyncGridLoaded) {
          return;
        }
        scope.asyncGridLoaded = true;
        return scope.$apply();
      };

      return init();
    },
  }));
